import React from "react";
const Content : React.FC = props =>
<div className="content mx-0">{props.children}</div>
export default Content;